/**
 * AudioManager class to manage the game audio and sound button state
 * @class AudioManager
 */
class AudioManager {
    // Singleton instance
    private static instance: AudioManager;
    // Public properties
    public isPlaying: boolean = false;
    public audio: HTMLAudioElement | null = null;
    public soundButtonState: string = "assets/img/sound/sound-on.png"; // Default state
    public static getInstance(): AudioManager {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!AudioManager.instance) {
            AudioManager.instance = new AudioManager();
        }
        return AudioManager.instance;
    }
}
/**
 * GameSoundComponent class to manage the game sound
*/
export class GameSoundComponent extends HTMLElement {
    private audioManager = AudioManager.getInstance();
    public constructor() {
        super();
        this.render();
    }

    private render(): void {
        this.innerHTML = `
            <div class="sound-button">
                <img id="sound" src="${this.audioManager.soundButtonState}" />
            </div>
        `;

        const soundButton: HTMLButtonElement | null = this.querySelector("#sound") as HTMLButtonElement;
        soundButton.addEventListener("click", () => this.toggleSound());
    }

    public async toggleSound(): Promise<void> {
        const soundButton: HTMLImageElement | null = this.querySelector("#sound");

        if (!this.audioManager.audio) {
            const gameSound: string = "assets/sounds/Future-Funk.mp3";
            this.audioManager.audio = new Audio(gameSound);

            // Ensure the audio loops
            this.audioManager.audio.loop = true;
        }

        if (this.audioManager.isPlaying) {
            // Pause the audio
            this.audioManager.audio.pause();
            this.audioManager.isPlaying = false;

            // Update the button icon to "play"
            if (soundButton) {
                soundButton.src = "assets/img/sound/sound-on.png";
                this.audioManager.soundButtonState = "assets/img/sound/sound-on.png";
            }
        }
        else {
            try {
                // Start playback
                await this.audioManager.audio.play();
                this.audioManager.isPlaying = true;

                // Update the button icon to "pause"
                if (soundButton) {
                    soundButton.src = "assets/img/sound/sound-off.png";
                    this.audioManager.soundButtonState = "assets/img/sound/sound-off.png";
                }
            }
            catch (error) {
                console.error("Failed to play audio:", error);
            }
        }
    }
}
